// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PRICE_CURRENCY_int = "%(int)s K\u010d";
export const PRICE_CURRENCY_int__float = "%(int)s,%(float)s K\u010d";
export const PRICE_FORFREE = "Daruji";
